var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stacked-line-chart-container" }, [
    _c("div", { ref: "chartContainer", staticClass: "chart-container" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }